import React from "react";
import { SimpleShowLayout } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { ArrayField, Datagrid, FunctionField, NumberField, ReferenceField, SelectField } from "react-admin";
import { getProfessorRecordText } from "server/components/Fields/_fieldsHelper";
import { ExamCommissionRoles } from "utils/choices";
import { settings } from "app";
import { employeeRequests } from "api/employeeApi";
import { SectionTitle } from "features/SectionTitle";

const SessionExamProfessorsInfo = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  return (
    <>
      <SectionTitle
        title="Преподаватели"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <SimpleShowLayout>
        <Grid
          container
          spacing={2}
          gap={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <ArrayField
              source="professors"
              label=""
            >
              <Datagrid
                rowClick={false}
                bulkActionButtons={false}
                sx={settings.style.detailsDatagrid}
              >
                <ReferenceField
                  source="professorEmployeeId"
                  reference={employeeRequests.getProfessorsSelect()}
                  linkType={false}
                  label="Преподавател"
                >
                  <FunctionField render={getProfessorRecordText} />
                </ReferenceField>

                <SelectField
                  source="role"
                  label="Роля"
                  choices={ExamCommissionRoles}
                  emptyText="-"
                />
                <NumberField
                  source="commissionNumber"
                  label="Комисия #"
                />
              </Datagrid>
            </ArrayField>
          </Grid>
        </Grid>{" "}
      </SimpleShowLayout>
    </>
  );
};

export default SessionExamProfessorsInfo;
